// extracted by mini-css-extract-plugin
module.exports = {"verifyingText":"styles_verifyingText__RB6UL","loadingText":"styles_loadingText__rkqi9"};